export default __webpack_public_path__ + "static/media/hackerrankGold.66d2d4b2.png";